<template>
    <div>
      <div class="title whiteBox">{{ $t('view.备件信息完善详情') }}</div>
      
      <div class="whiteBox">
        <el-form ref="form" :model="form" label-width="120px" style="display: flex;flex-wrap: wrap;">
            <div class="title" style="width: 100%;margin-bottom: 10px;">{{ $t('view.物资信息') }}</div>
            <el-form-item :label="$t('view.物资编码')" prop="materialCode">
                <el-input style="width: 320px;" v-model="form.materialCode" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.物资名称')" prop="materialName">
                <el-input style="width: 320px;" v-model="form.materialName" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.规格')" prop="specificationName">
                <el-input style="width: 320px;" v-model="form.specificationName" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.型号')" prop="model">
                <el-input style="width: 320px;" v-model="form.model" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.附件')" prop="declareName" style="width: 100%;">
                <div class="Mainclick" v-if="form.outFileList&&form.outFileList.length" @click="handleViewFile(form.outFileList[0].filePath , form.outFileList[0].fileName)">{{ form.outFileList[0].fileName }}</div>
            </el-form-item>
            <el-form-item :label="$t('view.驳回原因')" v-if="form.approvalOpinion"  prop="approvalOpinion" style="width: 880px;">
                <el-input v-model="form.approvalOpinion" disabled></el-input>
            </el-form-item>
            
        </el-form>
        <div class="title" style="width: 100%;margin-bottom: 10px;">{{ $t('view.备件信息') }}</div>
        <el-button  v-if="$route.query.type!='det'" type="primary" size="mini" @click="form.materialPartDetailList.push({outFileList:[], masterImgList:[]})">{{ $t('view.新增') }}</el-button>
        <el-table  border header-row-class-name="tableHeader" :data="form.materialPartDetailList" max-height="530px" style="width: 980px; margin: 10px 0 ">
            <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
            <el-table-column align="center"  width="200" show-overflow-tooltip :label="$t('view.备件名称')">
                <template slot-scope="scope" >
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.name"></el-input>
                    <span v-else>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.规格')">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.specificationName"></el-input>
                    <span v-else>{{ scope.row.specificationName }}</span>
                </template>
            </el-table-column>
             <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.型号')">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.model"></el-input>
                    <span v-else>{{ scope.row.model }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.计量单位')">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.unit"></el-input>
                    <span v-else>{{ scope.row.unit }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="140" show-overflow-tooltip :label="$t('view.数量')">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.number"></el-input>
                    <span v-else>{{ scope.row.number }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.更换周期')">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini" v-model="scope.row.replacementCycle"></el-input>
                    <span v-else>{{ scope.row.replacementCycle }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="140" show-overflow-tooltip :label="$t('view.单价')+'('+$t('view.元')+')'">
                <template slot-scope="scope">
                    <el-input v-if="$route.query.type!='det'" size="mini"
                        :value="scope.row.priceDisp !== undefined ? scope.row.priceDisp : scope.row.price"
                        @focus="moneyFocus(scope.row,'price','priceDisp')"
                        @input="moneyInput(scope.row,'price',$event)"
                        @blur="moneyBlur(scope.row,'price','priceDisp',getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark'))"></el-input>
                    <span v-else>
                        {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}
                        {{ formatNum(scope.row.price )}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.主图')">
                <template slot-scope="scope">
                    <div style="flex: 1" v-if="!scope.row.masterImgList.length">
                        <el-upload :action="uploadFile"  :limit="1"
                            :headers="headers" :on-success="(res,file)=>{successList(scope.row.masterImgList,res,file)}"
                            :on-remove="(res,file)=>{handleRemove('masterImgList',scope.$index)}">
                            <el-button type="primary" size="mini">{{ $t('view.上传附件') }}</el-button>                        
                        </el-upload>
                    </div>
                    <div v-else style="display: flex;width: 180px;align-items: center;">
                        <div class="Mainclick single-line" style="flex: 1;"  @click="handleViewFile(scope.row.masterImgList[0].filePath , scope.row.masterImgList[0].fileName)">{{ scope.row.masterImgList[0].fileName }}</div>
                        <img  v-if="$route.query.type!='det'" src="../../../assets/BidDetails/icon-close.png" @click="scope.row.masterImgList=[]" style="width: 10px;height: 10px;margin-left: 5px;"/>
                    </div>
                </template>
            </el-table-column>
             <el-table-column align="center" width="200" show-overflow-tooltip :label="$t('view.附件')">
                <template slot-scope="scope">
                      <div style="flex: 1" v-if="!scope.row.outFileList.length">
                        <el-upload :action="uploadFile"  :limit="1"
                            :headers="headers" :on-success="(res,file)=>{successList(scope.row.outFileList,res,file)}"
                            :on-remove="(res,file)=>{handleRemove('outFileList',scope.$index)}">
                            <el-button type="primary" size="mini">{{ $t('view.上传附件') }}</el-button>                        
                        </el-upload>
                    </div>
                    <div v-else style="display: flex;width: 180px;align-items: center;">
                        <div class="Mainclick single-line" style="flex: 1;"  @click="handleViewFile(scope.row.outFileList[0].filePath , scope.row.outFileList[0].fileName)">{{ scope.row.outFileList[0].fileName }}</div>
                        <img  v-if="$route.query.type!='det'" src="../../../assets/BidDetails/icon-close.png" @click="scope.row.outFileList=[]" style="width: 10px;height: 10px;margin-left: 5px;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" width="150"  v-if="$route.query.type!='det'" fixed="right" :label="$t('view.操作')">
                <template slot-scope="scope">
                    <span class="clickText" @click="form.materialPartDetailList.splice(scope.$index, 1)">{{ $t('view.删除') }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 20px;" v-if="$route.query.type!='det'">
            <el-button type="primary" size="mini" @click="PutMaterialPart(2)" style="margin-left: 20px;">{{ $t('view.提交') }}</el-button>
            <el-button type="primary" size="mini" plain @click="PutMaterialPart(1)" style="background: rgba(64,158,255,0.1);border: 1px solid #409EFF;color: #409EFF;">{{$t('view.保存')}}</el-button>
        </div>
      </div>
    </div>
  </template>
    
<script>
  import {getDicts} from '@/api/index'
  import { getToken } from "@/utils/auth";
  import { uploadFile } from '@/utils/request'
  import {getMaterialPart,PutMaterialPart} from '@/api/PersonalCenter'
  import {handleViewFile} from '@/api/common/common.js'
  export default {
    data(){
      return{
        uploadFile,
        handleViewFile,
        sys_currency:[],
        form:{},
        headers: {
            Authorization:getToken(),
        },
      }
    },
    created(){
        this.getDicts('sys_currency')//币种
        this.getMaterialPart()
    },
    methods:{
        moneyBlur(row, key, dispKey, currency) {
            let raw = row[key] === undefined || row[key] === null ? '' : String(row[key]).replace(/[^\d.\-]/g, '');
            if (raw === '' || isNaN(Number(raw))) { this.$set(row, dispKey, ''); return; }
            this.$set(row, dispKey, (currency || '') + this.formatNum(raw));
        },
        moneyFocus(row, key, dispKey) {
            const disp = row[dispKey];
            if (disp !== undefined && disp !== null && disp !== '') {
               row[key] = String(disp).replace(/[^\d.\-]/g, '');
            }
            if (dispKey) this.$set(row, dispKey, undefined);
        },
        moneyInput(row, key, val) {
            row[key] = val;
            if (row[key + 'Disp'] !== undefined) this.$set(row, key + 'Disp', undefined);
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        PutMaterialPart(status){
            if(!this.form.materialPartDetailList.length){
                this.$message.error(this.$t('view.请添加备件信息'));
                return
            }
            this.form.status=status
            PutMaterialPart(this.form).then(res=>{
                if(res.code==200){
                    this.$message.success(this.$t('view.操作成功'));
                    window.history.back();
                }
            })
        },
        
        // 删除
        handleRemove(list, index) {
            this.$set(this.form.materialPartDetailList[index],list,[])
        },
        getMaterialPart(){
            getMaterialPart(this.$route.query.id).then(res=>{
                console.log('aa',res)
                this.form=res.data
            })
        },
        // 上传文件
        successList(list,res,file){
            if(!list)
            list=[]
            list.push({
                fileName:file.response.newFileName,
                filePath:file.response.url,
                url: file.response.url, 
                type:file.response.newFileName.split(".").pop(),
                fileSize:file.size,

            })
        },
        beforeAvatarUpload(file){
                // image/png zip rar pdf
            if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
                this.$message.error(this.$t('view.格式有误'));
                return false
            }
            return true
        },
 
    }
};
  </script>
  <style>
  .line20 .el-form-item__label{
    line-height: 20px !important;
  }
  </style>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  .approvalComments{
    position: fixed;
    right: 10px;
    background: #fff;
    height: 200px;
    overflow-y: auto;
    padding: 20px;
    width: calc((100vw - 1400px) / 2);
    top: 370px;
  }
  </style>
   